import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy `/team` (a Tornado route on the old site) is discontinued — Nick, 2026-09-25.
 * Permanent home for anything still linking to it is the company page. Path→path
 * redirects live here as file routes, not in `legacy_url_redirect` (that table is
 * card/category-scoped by its CHECK constraint).
 */
export const Route = createFileRoute("/team")({
  beforeLoad: () => {
    throw redirect({ to: "/company", replace: true });
  },
});
